import { RootState } from "../../store";

export const schedulesStateSelector = (state: RootState) => state.schedules;
